// extracted by mini-css-extract-plugin
module.exports = {"titleIsListening":"styles_titleIsListening__22ysM","warning":"styles_warning__3HEet","tootlipTitle":"styles_tootlipTitle__3Q3Gi"};